import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IPaymentSystemSettings, PaymentSystemName } from '../types';
import { PAYMENT_SYSTEMS } from '../constants';

export interface ICurrentPaymentSystemComposable {
  currentPaymentSystem: Ref<IPaymentSystemSettings | undefined>;
  getPaymentSystem(name?: PaymentSystemName): IPaymentSystemSettings | undefined;
}

export default function useCurrentPaymentSystem(
  paymentSystemName?: Ref<PaymentSystemName | undefined>,
): ICurrentPaymentSystemComposable {
  const currentPaymentSystem = computed(() => paymentSystemName ? getPaymentSystem(paymentSystemName.value) : undefined);

  function getPaymentSystem(name?: PaymentSystemName): IPaymentSystemSettings | undefined {
    return PAYMENT_SYSTEMS.find((item) => item.name === name);
  }

  return {
    currentPaymentSystem,
    getPaymentSystem,
  };
}
